export default {
  id:                             '',
  user_id:                        '',
  expenses_cost_type:             '',
  bailiff_id:                     '',
  court_id:                       '',
  account_number:                 '',
  recipent:                       '',
  schedule_id:                    '',
  contract_case_id:               '',
  payment_type:                   'transfer',
  transfer_complete:              '0',
  cash_refunded:                  '0',
  transfer_title:                 '',
  comment:                        '',
  vehicle_id:                     null,
  amount:                         0
}
